import { QuantitySelectorComponent } from '@theme/component-quantity-selector';
 
/**
 * A custom element that allows the user to select a quantity in the cart.
 * Extends QuantitySelectorComponent but uses absolute max limits instead of effective max.
 * Semantics: "What should the total quantity BE in the cart" vs "How many to ADD to cart"
 *
 * @extends {QuantitySelectorComponent}
 */
class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  /**
   * Gets the effective maximum value for cart quantity selector
   * Cart page: uses absolute max (how much can be in cart total)
   * @returns {number | null} The effective max, or null if no max
   */
  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max; // Cart uses absolute max, not max minus cart quantity
  }
 
  /**
   * ===== PREORDER LOCK =====
   * The line is locked when Liquid rendered the input as disabled
   * (can_update_quantity == false, e.g. products tagged "preorder").
   * Read fresh from the DOM every time, so it survives cart re-renders.
   * @returns {boolean}
   */
  isLocked() {
    return this.refs.quantityInput?.disabled === true;
  }
 
  /**
   * Updates button states based on current value and limits
   */
  updateButtonStates() {
    const { minusButton, plusButton } = this.refs;
 
    // ===== PREORDER LOCK: keep both buttons disabled =====
    if (this.isLocked()) {
      minusButton.disabled = true;
      plusButton.disabled = true;
      return;
    }
 
    const { min, value } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();
 
    minusButton.disabled = value <= min;
    plusButton.disabled = effectiveMax !== null && value >= effectiveMax;
  }
 
  /**
   * ===== PREORDER LOCK: ignore any quantity change on a locked line =====
   * @param {number} stepMultiplier
   */
  updateQuantity(stepMultiplier) {
    if (this.isLocked()) {
      this.updateButtonStates();
      return;
    }
    super.updateQuantity(stepMultiplier);
  }
 
  /**
   * @param {Event} event
   */
  setQuantity(event) {
    if (this.isLocked()) {
      this.updateButtonStates();
      return;
    }
    super.setQuantity(event);
  }
}
 
if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}
 